import { use } from 'react';
import type { Context } from 'react';

const usePopulatedContext = <ItemType>(
  context: Context<ItemType | null>,
): ItemType => {
  const contextValue = use(context);

  if (contextValue === null) {
    throw Error('Context has not been Provided!');
  }

  return contextValue;
};

export default usePopulatedContext;
